import request from '@utils/Request.js'
import toast from '@utils/toast.js'

export default {
  commandDevice: async function (action, idDevice) {
    const url = '/admin/put/device/command'
    const body = {
      data: {
        device_id: idDevice,
        command: action,
      }
    }
    try {
      const response = await request(url, 'POST', body)
      if (response.code === 0) {
        toast.successMessage(`Device ${action}`)
      } else {
        toast.errorMessage(response.message)
      }
    } catch (e) {
      console.error(e)
    }
  }
}